import React from 'react';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { GridFooterContainer } from '@mui/x-data-grid';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import TablePagination from '@grnhse/seedling/lib/birch/components/table/components/pagination';
import { withLocalePrefix } from 'shared/utils/translation';
import { useUserContext } from 'talent_matching/contexts/user_context';

const t = withLocalePrefix('talent_matching');

const TableFooterContainer = styled(GridFooterContainer)`
  height: 56px;
  &.MuiDataGrid-withBorderColor {
    border-top: none;
  }
`;

const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${Tokens.spacing['2']};
`;

type Props = {
  rowsPerPage: number;
};

const DataViewTableFooter = ({ rowsPerPage }: Props) => {
  const { canViewTalentMatchingAiMatchScore } = useUserContext();

  return (
    <TableFooterContainer>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        paddingX={2}
      >
        <Grid item>
          {canViewTalentMatchingAiMatchScore && (
            <SecondaryBody metadata>
              {t('table.footer.ai_disclaimer')}
            </SecondaryBody>
          )}
        </Grid>
        <Grid item>
          <RightControls>
            {rowsPerPage ? (
              <SecondaryBody metadata>
                {t('table.footer.rows_per_page', { count: rowsPerPage })}
              </SecondaryBody>
            ) : null}
            <TablePagination />
          </RightControls>
        </Grid>
      </Grid>
    </TableFooterContainer>
  );
};

export default DataViewTableFooter;
